import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Dashboard from './pages/dashboard';
import VenueSearch from './pages/venue-search';
import MatchDetails from './pages/match-details';
import BarbecuePlanning from './pages/barbecue-planning';
import VenueOwnerDashboard from './pages/venue-owner-dashboard';
import UserProfile from './pages/user-profile';
import Login from './pages/login';
import Register from './pages/register';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/venue-search" element={<VenueSearch />} />
        <Route path="/match-details" element={<MatchDetails />} />
        <Route path="/match-details/:matchId" element={<MatchDetails />} />
        <Route path="/barbecue-planning" element={<BarbecuePlanning />} />
        <Route path="/venue-owner-dashboard" element={<VenueOwnerDashboard />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;